import Vue from 'vue'

import {
    filter as _filter,
    forEach as _forEach,
    orderBy as _orderBy,
} from 'lodash'

import OrderModel from '@/models/OrderModel'

import carService from '@/services/car.service'
import momentService from '@/services/moment'

// -----------------------------------------------------------------------------

const state = {
    isLoading: false,
    carHistory: {},
}

const getters = {
    getCarHistory: state => {
        const carHistory = _filter(state.carHistory, item => {
            return item.date < momentService.unix()
        })

        return _orderBy(carHistory, ['date'], ['desc'])
    },

    getCarHistoryByCarId: (state, getters) => carId => {
        const carHistory = _filter(getters.getCarHistory, { carId })

        return _orderBy(carHistory, ['date'], ['desc'])
    },

    getCarHistoryItem: state => carHistoryItemId => {
        return state.carHistory[carHistoryItemId] || null
    },
}

const mutations = {
    setLoading(state, isLoading) {
        state.isLoading = !!isLoading
    },

    setCarHistoryItems(state, payload) {
        state.cars = {}

        _forEach(payload, item => {
            const CarHistoryItem = new OrderModel(item)

            Vue.set(state.carHistory, CarHistoryItem.id, CarHistoryItem)
        })
    },

    setCarHistoryItem(state, payload) {
        const CarHistoryItem = new OrderModel(payload)

        Vue.set(state.carHistory, CarHistoryItem.id, CarHistoryItem)
    },
}

const actions = {
    async fetch({ commit }) {
        commit('setLoading', true)

        let response

        try {
            response = await carService.getCarsHistory()

            commit('setCarHistoryItems', response?.items || [])
            commit('setLoading', false)
        } catch (error) {
            commit('setLoading', false)
            return Promise.reject(error)
        }
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
